// extracted by mini-css-extract-plugin
export var list = "list-module--list--l52RJ";
export var list_ordered = "list-module--list_ordered--EXzXf";
export var list__item = "list-module--list__item--+qpXP";
export var list_customMarker = "list-module--list_custom-marker--c3rL-";
export var list__marker = "list-module--list__marker--3cRW7";